<template>
  <div id="otherInfo">
    <a-form
      ref="step14Ref"
      class="ant-round-form material-other-info-form"
      layout="vertical"
      :model="modelForm"
      :rules="rules"
      @finish="submit"
    >
      <a-form-item name="docPath" :label="$t('pages_merchant_129')">
        <div class="explain" style="margin-bottom: 24px">
          <span>{{ $t("pages_merchant_130") }}</span>
        </div>
        <upload-auto
          ref="uploadRef"
          v-model:file-content="modelForm.docPath"
          accept=".jpg,.jpeg,.png,.pdf,.bmp,.xls,.xlsx,.csv,.doc,.docx,.rar,.zip"
          type="INVITE"
          list-type="picture"
          back-type="array"
          :disabled="modelForm.docDisabled"
          :explain="$t('pages_merchant_032')"
          :max-count="10"
        />
        <div v-if="!modelForm.docDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.docMessage }}</span>
        </div>
      </a-form-item>

      <a-form-item name="supplyText" :label="$t('pages_merchant_131')">
        <a-textarea
          v-model:value="modelForm.supplyText"
          class="input-primary"
          :placeholder="$t('pages_merchant_132')"
          allow-clear
        />
        <div v-if="!modelForm.supplyDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.supplyMessage }}</span>
        </div>
      </a-form-item>
      <!-- 活体检测 -->
      <a-form-item
        name="faceRecognitionFileUrl"
        :label="countryCode === 'CN' ? $t('pages_merchant_147') : $t('pages_merchantInfo_150')"
      >
        <template v-if="!modelForm.faceRecognition">
          <div style="color: #BA8438; font-weight: 600; margin-bottom: 10px">
            {{ $t("pages_merchantInfo_153") }}
          </div>
          <span style="color: rgba(0, 0, 0, 0.6)">
            {{ $t("pages_merchantInfo_154") }}
          </span>
          <div v-if="countryCode === 'CN'" style="color: #f20b0b; margin-top: 10px;font-weight: 700;">
            * {{ $t("pages_merchantInfo_152") }}
          </div>
          <div v-else style="color: #f20b0b; margin-top: 10px;font-weight: 700;">
            * {{ $t("pages_merchantInfo_151") }}
          </div>
          <div
            style="
              background: #f9f9f9;
              padding: 12px;
              width: 360px;
              text-align: center;
              margin-top: 20px;
            "
          >
            {{ $t("pages_merchantInfo_155") }}
            <span style="color: #BA8438; cursor: pointer" @click="bioassayClick">{{ $t("pages_merchantInfo_156") }}</span>
            {{ $t("pages_merchantInfo_157") }}
          </div>
        </template>
        <template v-else>
          <div
            style="
              background: #f9f9f9;
              padding: 12px;
              width: 360px;
              text-align: center;
              margin-top: 20px;
            "
          >
            {{ $t("pages_merchantInfo_158") }}
          </div>
        </template>
        <div v-if="modelForm.faceMessage" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.faceMessage }}</span>
        </div>
      </a-form-item>

      <a-form-item style="text-align: right; margin-top: 48px">
        <a-button
          type="primary"
          shape="round"
          ghost
          style="min-width: 138px; margin-right: 24px"
          @click="$emit('next', '3-1')"
        >{{ $t("pages_merchant_040") }}</a-button>
        <a-button html-type="submit" type="primary" shape="round" style="min-width: 138px">{{ $t("pages_merchant_020")
        }}</a-button>
      </a-form-item>
    </a-form>
    <a-modal
      :visible="visible"
      :title="$t('pages_merchant_148')"
      :centered="true"
      :body-style="{ textAlign: 'center' }"
      class="face-modal"
      @cancel="handleCancel"
    >
      <template #footer>
        <div style="display: flex; justify-content: space-evenly">
          <a-button key="back" @click="bioassayClick">{{ $t("pages_merchantInfo_159") }}</a-button>
          <a-button
            key="submit"
            :loading="loading"
            style="width: 200px;background: #BA8438;color: #fff;border-color:#BA8438;"
            @click="handleOk"
          >{{ $t("pages_merchantInfo_158") }}</a-button>
        </div>
      </template>
      <p>{{ $t("pages_merchantInfo_160") }}</p>
      <p>{{ $t("pages_merchantInfo_161") }}</p>
      <p>{{ $t("pages_merchantInfo_162") }}</p>
      <img :src="base64Image" alt="Base64 Image" style="width: 200px; height: 200px">
    </a-modal>
  </div>
</template>
<script>
import { ref, reactive, toRefs, computed, nextTick } from 'vue'
import { message } from 'ant-design-vue'
import { _user } from '@/api'
import UploadAuto from '@/components/upload-auto'
export default {
  name: 'OtherInfo',
  components: {
    'upload-auto': UploadAuto
  },
  props: {
    model: {
      type: Object,
      default: () => {
        return {}
      }
    },
    refused: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    liveness: {
      type: Boolean,
      default: () => {
        return true
      }
    },
    kycid: {
      type: String,
      default: () => {
        return ''
      }
    },
    risked: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    countryCode: {
      type: String,
      default: () => { return '' }
    }
  },
  setup(props, ctx) {
    const step14Ref = ref(null)
    const uploadRef = ref(null)
    const base64Image = ref(null)
    const visible = ref(false)
    const state = reactive({
      rules: {
        faceRecognitionFileUrl: [{ required: props.liveness, message: '请进行人脸验证' }]
      }
    })

    state.modelForm = computed(() => {
      return props.model
    })

    const submit = () => {
      ctx.emit('next', props.risked ? '3-2' : '3-4')
    }

    const bioassayClick = async () => {
      // visible.value = true
      try {
        const res = await _user.faceGetQrCode({ kycId: props.kycid }) // 请求数据
        console.log(res, 'base64Image')
        base64Image.value = 'data:image/png;base64,' + res.data.data
        visible.value = true
      } catch (error) {
        console.error('请求失败', error)
      } finally {
        // loading.value = false // 请求完成，停止 loading
      }
    }
    const handleOk = async () => {
      try {
        const res = await _user.faceGetRecognitionResult({
          kycId: props.kycid
        }) // 请求数据
        console.log(res, 'handleOk+++++++++++++')
        if (res.data.data.passed) {
          state.modelForm.faceRecognition = res.data.data.certifyId
          state.modelForm.faceRecognitionResult =
            res.data.data.passed.toString()
          state.modelForm.faceRecognitionFileUrl = res.data.data.pictureUrl
          message.success('认证成功')
        } else {
          message.error('请重新认证')
        }
        visible.value = false
      } catch (error) {
        message.error('请重新认证')
      } finally {
        // loading.value = false // 请求完成，停止 loading
      }
    }
    const handleCancel = () => {
      visible.value = false
    }
    nextTick(() => {
      const { docPath } = state.modelForm
      if (docPath.length !== 0 && uploadRef.value) {
        uploadRef.value.fileListRefresh(docPath)
      }
    })

    return {
      step14Ref,
      uploadRef,
      visible,
      base64Image,
      handleCancel,
      submit,
      bioassayClick,
      handleOk,
      ...toRefs(state)
    }
  }
}
</script>
<style lang="less" scoped>
#otherInfo {
  .material-other-info-form {
    .explain {
      color: #495060;
    }

    .input-primary:deep(.ant-input) {
      border-radius: 5px;
    }
  }
}
</style>
